import { Injectable } from '@angular/core';

@Injectable()
export class ColorsService {

  public APP_COLORS = {
    primary: '#3F51B5',
    success: '#4CAF50',
    info: '#2196F3',
    warning: '#FF9800',
    danger: '#F44336',
    inverse: '#607D8B',
    green: '#009688',
    pink: '#E91E63',
    purple: '#673AB7',
    dark: '#263238',
    yellow: '#FFEB3B',
    'gray-darker': '#232735',
    'gray-dark': '#3a3f51',
    gray: '#dde6e9',
    'gray-light': '#e4eaec',
    'gray-lighter': '#edf1f2',

    // ## Light Blue
    'light-blue-50': '#E1F5FE',
    'light-blue-100': '#B3E5FC',
    'light-blue-200': '#81D4FA',
    'light-blue-300': '#4FC3F7',
    'light-blue-400': '#29B6F6',
    'light-blue-500': '#03A9F4',
    'light-blue-600': '#039BE5',
    'light-blue-700': '#0288D1',
    'light-blue-800': '#0277BD',
    'light-blue-900': '#01579B',
    'light-blue-A100': '#80D8FF',
    'light-blue-A200': '#40C4FF',
    'light-blue-A400': '#00B0FF',
    'light-blue-A700': '#0091EA',

    // ## Indigo
    'indigo-50': '#E8EAF6',
    'indigo-100': '#C5CAE9',
    'indigo-200': '#9FA8DA',
    'indigo-300': '#7986CB',
    'indigo-400': '#5C6BC0',
    'indigo-500': '#3F51B5',
    'indigo-600': '#3949AB',
    'indigo-700': '#303F9F',
    'indigo-800': '#283593',
    'indigo-900': '#1A237E',
    'indigo-A100': '#8C9EFF',
    'indigo-A200': '#536DFE',
    'indigo-A400': '#3D5AFE',
    'indigo-A700': '#304FFE',

    // ## Pink
    'pink-50': '#FCE4EC',
    'pink-100': '#F8BBD0',
    'pink-200': '#F48FB1',
    'pink-300': '#F06292',
    'pink-400': '#EC407A',
    'pink-500': '#E91E63',
    'pink-600': '#D81B60',
    'pink-700': '#C2185B',
    'pink-800': '#AD1457',
    'pink-900': '#880E4F',
    'pink-A100': '#FF80AB',
    'pink-A200': '#FF4081',
    'pink-A400': '#F50057',
    'pink-A700': '#C51162',

    // ## Purple
    'purple-50': '#F3E5F5',
    'purple-100': '#E1BEE7',
    'purple-200': '#CE93D8',
    'purple-300': '#BA68C8',
    'purple-400': '#AB47BC',
    'purple-500': '#9C27B0',
    'purple-600': '#8E24AA',
    'purple-700': '#7B1FA2',
    'purple-800': '#6A1B9A',
    'purple-900': '#4A148C',
    'purple-A100': '#EA80FC',
    'purple-A200': '#E040FB',
    'purple-A400': '#D500F9',
    'purple-A700': '#AA00FF',

    // ## Green
    'green-50': '#E8F5E9',
    'green-100': '#C8E6C9',
    'green-200': '#A5D6A7',
    'green-300': '#81C784',
    'green-400': '#66BB6A',
    'green-500': '#4CAF50',
    'green-600': '#43A047',
    'green-700': '#388E3C',
    'green-800': '#2E7D32',
    'green-900': '#1B5E20',
    'green-A100': '#B9F6CA',
    'green-A200': '#69F0AE',
    'green-A400': '#00E676',
    'green-A700': '#00C853',
    // ## Cyan
    'cyan-50': '#E0F7FA',
    'cyan-100': '#B2EBF2',
    'cyan-200': '#80DEEA',
    'cyan-300': '#4DD0E1',
    'cyan-400': '#26C6DA',
    'cyan-500': '#00BCD4',
    'cyan-600': '#00ACC1',
    'cyan-700': '#0097A7',
    'cyan-800': '#00838F',
    'cyan-900': '#006064',
    'cyan-A100': '#84FFFF',
    'cyan-A200': '#18FFFF',
    'cyan-A400': '#00E5FF',
    'cyan-A700': '#00B8D4',

    // ## blue-grey

    'blue-grey-50': '#ECEFF1',
    'blue-grey-100': '#CFD8DC',
    'blue-grey-200': '#B0BEC5',
    'blue-grey-300': '#90A4AE',
    'blue-grey-400': '#78909C',
    'blue-grey-500': '#607D8B',
    'blue-grey-600': '#546E7A',
    'blue-grey-700': '#455A64',
    'blue-grey-800': '#37474F',
    'blue-grey-900': '#263238',

  };

  public PALLETE_THEME_A = [
    this.APP_COLORS['light-blue-900'],
    this.APP_COLORS['light-blue-600'],
    this.APP_COLORS['light-blue-300'],
    this.APP_COLORS['light-blue-100'],
    this.APP_COLORS['light-blue-500'],
    this.APP_COLORS['light-blue-700'],
    this.APP_COLORS['light-blue-800'],
  ];

  public PALLETE_THEME_B = [
    this.APP_COLORS['indigo-700'],
    this.APP_COLORS['indigo-500'],
    this.APP_COLORS['indigo-300'],
    this.APP_COLORS['indigo-100'],
    this.APP_COLORS['indigo-400'],
    this.APP_COLORS['indigo-600'],
    this.APP_COLORS['indigo-800'],
  ];

  public PALLETE_THEME_C = [
    this.APP_COLORS['purple-900'],
    this.APP_COLORS['purple-700'],
    this.APP_COLORS['purple-500'],
    this.APP_COLORS['purple-300'],
    this.APP_COLORS['purple-100'],
    this.APP_COLORS['purple-400'],
    this.APP_COLORS['purple-600'],
    this.APP_COLORS['purple-800'],
  ];

  public PALLETE_THEME_D = [
    this.APP_COLORS['green-900'],
    this.APP_COLORS['green-700'],
    this.APP_COLORS['green-500'],
    this.APP_COLORS['green-300'],
    this.APP_COLORS['green-100'],
    this.APP_COLORS['green-400'],
    this.APP_COLORS['green-600'],
  ];

  public PALLETE_THEME_E = [
    this.APP_COLORS['cyan-900'],
    this.APP_COLORS['cyan-700'],
    this.APP_COLORS['cyan-500'],
    this.APP_COLORS['cyan-200'],
    this.APP_COLORS['cyan-50'],
    this.APP_COLORS['cyan-400'],
    this.APP_COLORS['cyan-600'],
  ];

  public PALLETE_THEME_F = [
    this.APP_COLORS['pink-700'],
    this.APP_COLORS['pink-500'],
    this.APP_COLORS['pink-300'],
    this.APP_COLORS['pink-100'],
    this.APP_COLORS['pink-400'],
    this.APP_COLORS['pink-600'],
    this.APP_COLORS['pink-800'],
  ];

  public PALLETE_THEME_G = [
    this.APP_COLORS['blue-grey-700'],
    this.APP_COLORS['blue-grey-500'],
    this.APP_COLORS['blue-grey-300'],
    this.APP_COLORS['blue-grey-100'],
    this.APP_COLORS['blue-grey-400'],
    this.APP_COLORS['blue-grey-600'],
    this.APP_COLORS['blue-grey-800'],
  ];

  public PALLETE_THEME_H = [
    this.APP_COLORS['blue-grey-900'],
    this.APP_COLORS['blue-grey-800'],
    this.APP_COLORS['blue-grey-600'],
    this.APP_COLORS['blue-grey-400'],
    this.APP_COLORS['blue-grey-200'],
    this.APP_COLORS['blue-grey-50'],
    this.APP_COLORS['blue-grey-300'],
  ];

  constructor() { }

  public byName(name: string): string {
    // console.log(name +' -> ' + this.APP_COLORS[name])
    return (this.APP_COLORS[name] || '#fff');
  }

  public getPalleteByTheme(name: string): string[] {
    switch (name) {
      case 'A':
      case 'a':
        return this.PALLETE_THEME_A;
      case 'B':
      case 'b':
        return this.PALLETE_THEME_B;
      case 'C':
      case 'c':
        return this.PALLETE_THEME_C;
      case 'D':
      case 'd':
        return this.PALLETE_THEME_D;
      case 'E':
      case 'e':
        return this.PALLETE_THEME_E;
      case 'F':
      case 'f':
        return this.PALLETE_THEME_F;
      case 'G':
      case 'g':
        return this.PALLETE_THEME_G;

      case 'H':
      case 'h':
        return this.PALLETE_THEME_H;
    }
  }

}
